import React from 'react';

import { IEditorContext } from './types';

export const EditorContext = React.createContext<IEditorContext | any>({});
